import React from 'react'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import styles from './RecommendedVenuesCard.module.scss'

export default function RecommendedVenuesCard({
	image,
	title,
	location,
	hours,
	capacity,
	tags,
	onDetailsClick,
}) {
	return (
		<div className={styles.recommendedVenuesCard}>
			<figure className={styles.recommendedVenuesImage}>
				<img src={image} alt={title} />
			</figure>

			<div className={styles.recommendedVenuesContents}>
				<h4>{title}</h4>
				<div className={styles.recommendedVenuesContentText}>
					<p>
						<img src="/images/location.svg" alt="Location" />{' '}
						{location}
					</p>
					<p>
						<img src="/images/time-icon.svg" alt="Hours" /> {hours}
					</p>
				</div>
			</div>

			<div className={styles.recommendedVenuesContent}>
				<div className={styles.recommendedVenuesCapacityTag}>
					<p>
						<img src="/images/Capacity.svg" alt="Capacity" />{' '}
						<span>Capacity</span> {capacity}
					</p>
				</div>

				<div className={styles.recommendedVenuesContentTag}>
					{tags.map((tag, i) => (
						<p key={i}>
							<img src={`/images/${tag}.svg`} alt={tag} /> {tag}
						</p>
					))}
				</div>

				<ButtonCustom variant="outlined" onClick={onDetailsClick}>
					Details
					<img src="/images/ArrowRight.svg" alt="ArrowRight" />
				</ButtonCustom>
			</div>
		</div>
	)
}
